import React from "react";
import { useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import {
  SpineAvatarPicker,
  type SpineAvatarPickerSelection,
  type SpineAvatarPickerPinned,
} from "../../../../components/SpineAvatarPicker";
import { TemplateStaticImagePreview } from "./TemplateStaticImagePreview";

interface SpineInitDataPickerProps {
  value?: string;
  coverUrl?: string;
  pinnedItems?: SpineAvatarPickerPinned[];
  onSelect: (
    avatarId: string,
    avatarUrl?: string,
    videoCover?: string,
    videoCoverPreview?: string,
  ) => void;
  label?: string;
  placeholder?: string;
}

export function SpineInitDataPicker({
  value,
  coverUrl,
  pinnedItems,
  onSelect,
  label,
}: SpineInitDataPickerProps) {
  const { tid } = useParams<{ tid: string }>();

  if (!tid) {
    return null;
  }

  const handleSelect = (avatar: SpineAvatarPickerSelection) => {
    onSelect(
      avatar.id,
      avatar.url,
      avatar.videoUrl || "",
      avatar.videoPreviewUrl || "",
    );
  };

  return (
    <div className="space-y-2">
      {label && <Label>{label}</Label>}
      <div className="flex gap-2">
        <div className="flex-1">
          <input
            type="text"
            value={value || ""}
            readOnly
            className="w-full px-3 py-2 border rounded-md bg-muted/50 text-sm"
          />
        </div>
        <SpineAvatarPicker
          tid={tid}
          currentAvatarId={value}
          pinnedItems={pinnedItems}
          onSelect={handleSelect}
        >
          <Button variant="outline">选择 Avatar</Button>
        </SpineAvatarPicker>
      </div>

      {coverUrl && (
        <TemplateStaticImagePreview label="Cover 预览" imageUrl={coverUrl} />
      )}
    </div>
  );
}
